import request from "@/router/axios"
export const list = () => {
    return request({
        url: `/api/basis/print/template/getArray`,
        method: 'get',
    })
}
export function save(data) {
    return request({
        url: `/api/basis/print/template/add`,
        method: 'post',
        data
    })
}
export function edit(data) {
    return request({
        url: `/api/basis/print/template/edit`,
        method: 'post',
        data
    })
}
export const remove = (ids) => {
    return request({
        url: `/api/basis/print/template/del`,
        method: "post",
        params: {
            ids,
        },
    });
};